export const locale = {
    lang: 'pl',
    data: {
        "Details": "Szczegóły",
        "From": "Od",
        "To": "Do",
        "Time": "Czas",
        "Close": "Zamknij",
        "Loading details...": "Wczytywanie szczegółów...",
    }
};
